<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <button
            type="button"
            class="btn btn-primary"
            :disabled="isButtonGenerateDisable"
            @click="handleAutoMessage"
        >
          {{ buttonAI }}
        </button>
        <div :class="loadingAnimation">
          <div class="snippet mt-3 ml-3" data-title="dot-bricks">
            <div class="stage">
              <div class="dot-bricks"></div>
            </div>
          </div>
        </div>
      </div>
      <div :class="feedbackContainer">
        <button
            :class="likeButton"
            type="button"
            :ref="likeButtonClicked"
            :disabled="isButtonFeedbackDisable"
            v-on:click="saveFeedback(1)"
        >
          <i class="fa fa-thumbs-up"></i>
        </button>
        <button
            :class="dislikeButton"
            type="button"
            :ref="dislikeButtonClicked"
            :disabled="isButtonFeedbackDisable"
            v-on:click="saveFeedback(0)"
        >
          <i class="fa fa-thumbs-down"></i>
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <input type="text" class="hide" :value="openAIResponse" id="hidden-open-ai-response">
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import OpenAi from 'openai';
import _ from 'lodash';
import Swal from 'sweetalert2'
import Noty from 'noty';
import * as $ from 'jquery';

export default {
  props: {
    ticketId: {
      type: Number,
      default: '',
    },
    ticketType: {
      type: String,
      default: ''
    },
    clientName: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.getTicket()
    this.initOpenAI()
  },
  data() {
    return {
      ticketData: {
        threadId: '',
        success: false,
        message: {
          id: '',
          question: '',
          subject: '',
          type: '',
          conversation: [],
        },
        language: '',
      },
      isButtonGenerateDisable: false,
      isButtonFeedbackDisable: false,
      buttonAI: 'Write using AI',
      openAI: {},
      loadingAnimation: 'hide',
      feedbackContainer: 'hide',
      openAIResponse: '',
      feedbackId: 0,
      likeButtonClicked: false,
      likeButton: 'btn btn-outline-info',
      dislikeButtonClicked: false,
      dislikeButton: 'btn btn-outline-danger',
      deleteFeedback: false,
    }
  },
  watch: {
    likeButtonClicked: function (val) {
      this.likeButton = val ? 'btn btn-info' : 'btn btn-outline-info';
    },
    dislikeButtonClicked: function (val) {
      this.dislikeButton = val ? 'btn btn-danger' : 'btn btn-outline-danger';
    },
    openAIResponse: function (val) {
      if (val === '') {
        this.feedbackContainer = 'hide'
      }
    }
  },
  methods: {
    async initOpenAI() {
      this.openAI = new OpenAi({
        apiKey: process.env.MIX_OPENAI_API_KEY,
        dangerouslyAllowBrowser: true
      })
    },
    async getTicket() {
      const ticketData = await axios.get(`/admin/ticket-detail/${this.ticketType}/${this.ticketId}`)
      this.ticketData = await ticketData.data;
    },
    createThreadUniverse() {
      axios.post(`/admin/ticket-detail/create/thread/${this.ticketType}/${this.ticketId}`, {
        threadId: this.ticketData.threadId
      })
    },
    async createThreadOpenAI() {
      const thread = await this.openAI.beta.threads.create();
      this.ticketData.threadId = thread.id;
      this.createThreadUniverse()
    },
    async createMessageOpenAI() {
      await this.openAI.beta.threads.messages.create(
          this.ticketData.threadId,
          {
            role: 'user',
            content: [
              {
                'type': 'text',
                'text': `Please address the name of client is ${this.clientName}. `
              },
              {
                'type': 'text',
                'text': `${JSON.stringify(this.ticketData.message.conversation)}. This data is conversation that made before between client and agent to references the conversation per ticket number. The data is json encoded and have the id that represent ticket number. Always using the file_search tool to get more references from the other agent`
              },
              {
                'type': 'text',
                'text': `${this.ticketData.message.question}  (answer this as instructed, don't forget to say greetings with mentioning the client first name, reply using ${this.ticketData.language} language)`,
              }
            ]
          },
      );
    },
    async removeSourceCitation() {
      let content = window.quill.getText();
      let removeCitationInEditor = content.replace(/\【.*?】/g, "");
      window.quill.setText(removeCitationInEditor);
    },
    async repairContent() {
      let content = window.quill.getText();
      let repairedContent = content.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
      repairedContent = repairedContent.split('\n').map(line => {
        if(line.trim().length > 0) {
          return `<p>${line}</p>`
        }
        return `${line}<br>`;
      }).join('');
      window.quill.clipboard.dangerouslyPasteHTML(repairedContent);
    },
    async runOpenAIAssistant() {
      this.openAI.beta.threads.runs.stream(this.ticketData.threadId, {
        assistant_id: process.env.MIX_OPENAI_TICKET_ASSISTANT
      })
        .on('textCreated', (text) => this.buttonAI = 'Start writing')
        .on('textDelta', (textDelta, snapshot) => this.appendToEditor(textDelta.value))
        .on('toolCallCreated', (toolCall) => console.log(`\nassistant > ${toolCall.type}\n\n`))
        .on('messageDone', async (message) => {
          await this.removeSourceCitation();
          await this.repairContent();
          this.buttonAI = 'Write using AI';
          this.isButtonGenerateDisable = false;
          this.loadingAnimation = 'hide';
          this.openAIResponse = window.quill.getText();
          this.feedbackContainer = '';
          $('#reply-button').prop( 'disabled', false ).css( 'display', 'inline-block' );
        });
    },
    appendToEditor(content) {
      if (window.quill) {
        this.buttonAI = 'Generating message';
        const currentLength = window.quill.getLength();
        window.quill.insertText(currentLength - 1, content, Quill.sources.API);
        window.quill.setSelection(currentLength + content.length - 1);
      }
    },
    handleAutoMessage: _.debounce(async function() {
      if (window.quill.getLength() > 1) {
        Swal.fire({
          title: 'Warning',
          text: 'Reset Ticket Form?',
          icon: 'warning',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
        }).then(async (value) => {
          if (value.isConfirmed && value.isDismissed === false) {
            window.quill.setText('');
            this.ticketData.threadId = '';
            await this.generateMessage();
          } else {
            await this.generateMessage();
          }
        })
      } else {
        await this.generateMessage();
      }
    }, 500, { leading: true, trailing: true }),
    async generateMessage() {
      this.openAIResponse = '';
      if (!this.isButtonGenerateDisable) {
        this.isButtonGenerateDisable = true;
        this.loadingAnimation = '';
        this.buttonAI = 'Assistant is thinking';

        if (this.ticketData.success) {
          if (this.ticketData.threadId.length < 1 || this.ticketData.threadId === '') {
            await this.createThreadOpenAI();
          }
          await this.createMessageOpenAI();
          await this.runOpenAIAssistant();
        }
      }
    },
    saveFeedback: _.debounce(async function(rating) {
      if (!this.isButtonFeedbackDisable) {
        this.isButtonFeedbackDisable = true;
        if (parseInt(rating) === 1) {
          this.likeButtonClicked = !this.likeButtonClicked;
          if (this.likeButtonClicked) this.dislikeButtonClicked = false;
          rating = this.likeButtonClicked ? 1 : 0.5;
        } else {
          this.dislikeButtonClicked = !this.dislikeButtonClicked;
          if (this.dislikeButtonClicked) this.likeButtonClicked = false;
          rating = this.dislikeButtonClicked ? 0 : 0.5;
        }
        await axios.post('/admin/openai/feedback', {
          rating,
          openAIResponse: this.openAIResponse,
          openAIThread: this.ticketData.threadId,
          ticketData: JSON.stringify(this.ticketData.message),
          ticketId: this.ticketId,
          ticketType: (this.ticketType === 'student') ? 'tickets' : 'tickets_leads',
          feedbackId: this.feedbackId,
        })
          .then(res => {
            if (res.data.success) {
              if (!res.data.neutral) {
                new Noty({
                  type: 'success',
                  text: res.data.message,
                  timeout: 1500,
                }).show();
              }
              this.feedbackId = res.data.feedback_id;
            } else {
              new Noty({
                type: 'error',
                text: res.data.message,
                timeout: 1500,
              }).show();
            }
          })
          .catch(err => {
            new Noty({
              type: "error",
              text: 'Something wrong happened',
              timeout: 1500,
            }).show();
          })
          .finally(this.isButtonFeedbackDisable = false)
      }
    }, 500, { leading: true, trailing: true }),
  }
}
</script>

<style scoped>
.dot-bricks {
  position: relative;
  top: 8px;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #009f91;
  color: #009f91;
  box-shadow: 9991px -16px 0 0 #009f91, 9991px 0 0 0 #009f91, 10007px 0 0 0 #009f91;
  animation: dot-bricks 2s infinite ease;
}

@keyframes dot-bricks {
  0% {
    box-shadow: 9991px -16px 0 0 #009f91, 9991px 0 0 0 #009f91, 10007px 0 0 0 #009f91;
  }
  8.333% {
    box-shadow: 10007px -16px 0 0 #009f91, 9991px 0 0 0 #009f91, 10007px 0 0 0 #009f91;
  }
  16.667% {
    box-shadow: 10007px -16px 0 0 #009f91, 9991px -16px 0 0 #009f91, 10007px 0 0 0 #009f91;
  }
  25% {
    box-shadow: 10007px -16px 0 0 #009f91, 9991px -16px 0 0 #009f91, 9991px 0 0 0 #009f91;
  }
  33.333% {
    box-shadow: 10007px 0 0 0 #009f91, 9991px -16px 0 0 #009f91, 9991px 0 0 0 #009f91;
  }
  41.667% {
    box-shadow: 10007px 0 0 0 #009f91, 10007px -16px 0 0 #009f91, 9991px 0 0 0 #009f91;
  }
  50% {
    box-shadow: 10007px 0 0 0 #009f91, 10007px -16px 0 0 #009f91, 9991px -16px 0 0 #009f91;
  }
  58.333% {
    box-shadow: 9991px 0 0 0 #009f91, 10007px -16px 0 0 #009f91, 9991px -16px 0 0 #009f91;
  }
  66.666% {
    box-shadow: 9991px 0 0 0 #009f91, 10007px 0 0 0 #009f91, 9991px -16px 0 0 #009f91;
  }
  75% {
    box-shadow: 9991px 0 0 0 #009f91, 10007px 0 0 0 #009f91, 10007px -16px 0 0 #009f91;
  }
  83.333% {
    box-shadow: 9991px -16px 0 0 #009f91, 10007px 0 0 0 #009f91, 10007px -16px 0 0 #009f91;
  }
  91.667% {
    box-shadow: 9991px -16px 0 0 #009f91, 9991px 0 0 0 #009f91, 10007px -16px 0 0 #009f91;
  }
  100% {
    box-shadow: 9991px -16px 0 0 #009f91, 9991px 0 0 0 #009f91, 10007px 0 0 0 #009f91;
  }
}
</style>